jQuery = $ = require('jquery');

$(function () {
    var isMobile = false; //initiate as false

    // device detection
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isMobile = true;

    /**
     * Слайдер "Посмотрите наши двери"
     */
    $('.js-our-doors').owlCarousel({
        loop: true,
        nav: true,
        items: 1
    });

    /**
     * Слайдер "Конструктив"
     */
    $('.js-construct').owlCarousel({
        loop: true,
        dots: true,
        items: 1
    });

    /**
     * Слайдер "Защита"
     */
    $('.js-defense').owlCarousel({
        loop: true,
        dots: true,
        items: 1
    });

    /**
     * Слайдер цветов к группе конфигуратора
     */
    $('.js-colors-slider').owlCarousel({
        loop: true,
        dots: true,
        nav: true,
        items: 1
    });

    $('.js-colors-slider .preview').mouseenter(function() {
        $(this).parents('.js-colors-slider').find('.owl-nav').css('z-index', '0');
        $(this).parents('.js-colors-slider').find('.owl-dots').css('z-index', '0');
    });

    $('.js-colors-slider .preview').mouseleave(function() {
        $(this).parents('.js-colors-slider').find('.owl-nav').css('z-index', '5');
        $(this).parents('.js-colors-slider').find('.owl-dots').css('z-index', '5');
    });

    /**
     * Слайдер "Дизайн"
     */
    $('.js-design').owlCarousel({
        loop: true,
        dots: true,
        items: 1
    });

    $('.js-actions-slider').owlCarousel({
        loop: true,
        dots: true,
        nav: true,
        items: 1,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true
    });

    /**
     * Слайдер всех моделей на главной
     */
    $('.js-door-models').owlCarousel({
        loop: true,
        dots: false,
        nav: true,
        responsive: {
            992: {
                items: 5
            },
            768: {
                items: 2
            },
            0: {
                items: 1
            }
        }
    });

    /**
     * Слайдер других моделей
     */
    var otherCount = $('.other-models .owl-carousel > a.item').length;
    if (otherCount > 3) {
        otherCount = 3;
    }

    $('.js-other-models').owlCarousel({
        loop: true,
        dots: true,
        responsive: {
            992: {
                items: otherCount
            },
            768: {
                items: 2
            },
            0: {
                items: 1
            }
        }
    });

    /**
     * Слайдер партнеров
     */
    $('.js-partners').owlCarousel({
        loop: true,
        nav: false,
        dots: true,
        responsive: {
            992: {
                items: 6
            },
            768: {
                items: 4
            },
            0: {
                items: 2
            }
        }
    });

    /**
     * Слайдер сертификатов
     */
    $('.js-certificates').owlCarousel({
        loop: true,
        nav: false,
        dots: true,
        dotsEach: 1,
        responsive: {
            992: {
                items: 6
            },
            768: {
                items: 4
            },
            0: {
                items: 2
            }
        }
    });

    // Проставляем высоту у блока с ценой
    $('.js-price-block-wrapper').css('height', $('.js-price-block-wrapper').height());
    $('.js-price-block').css('width', $('.js-price-block').width());

    /**
     * Высота слайдов
     *
     * @type {number}
     */
    var maxHeight = 0,
        equalHeight = $('.js-equal-height');

    equalHeight.find('.item').each(function () {
        if ($(this).height() > maxHeight) {
            maxHeight = $(this).height();
        }
    });

    equalHeight.find('.item').height(maxHeight);

    /**
     * Yandex maps
     */
    ymaps.ready(init);
    var myMap,
        pinStyle;

    function init() {
        myMap = new ymaps.Map("map", {
            center: [longitude, latitude],
            zoom: 11,
            controls: ['default']
        });

        pinStyle =  {
            iconColor: '#ED2939'
        };

        if (typeof dealers !== 'undefined') {
            dealers.forEach(function(dealer, index) {
                var mapObj = new ymaps.Placemark([dealer['lon'], dealer['lat']], {
                    hintContent: dealer['name'],
                    balloonContent: dealer['address']
                }, pinStyle);
                myMap.geoObjects.add(mapObj);
            });
        }

        myMap.behaviors.disable(['scrollZoom']);

        if (isMobile) {
            myMap.behaviors.disable(['drag']);
        }

    }

    /**
     * Мобильное меню
     */
    $('.js-mobile-menu-btn').click(function () {
        if ($(this).hasClass('is-active')) {
            $(this).removeClass('is-active');
            closeMenu();
        } else {
            $(this).addClass('is-active');
            openMenu();
        }
    });

    $('.overlay').click(function () {
        $('.js-mobile-menu-btn').trigger('click');
    });

    /**
     * Открыть меню
     */
    function openMenu() {
        var $el = $('.js-mobile-menu-wrapper');

        $el.find('.js-mobile-menu').animate({'left': '0px'});
        $el.find('.overlay').fadeIn();
    }

    /**
     * Закрыть меню
     */
    function closeMenu() {
        var $el = $('.js-mobile-menu-wrapper');

        $el.find('.js-mobile-menu').animate({'left': '-280px'});
        $el.find('.overlay').fadeOut();
    }

    /**
     * Зум в конфигураторе
     */

    $('.zoom').each(function () {
        $(this).zoom(
            {
                url: $(this).attr('src'),
            }
        );
    });

    $('.scroll-to').click(function () {
        $('html, body').animate({
            scrollTop: $($(this).data('target')).offset().top - 110
        }, 1000)
    });

    /**
     * Возвращает true, если элемент виден
     *
     * @param el
     * @returns {boolean}
     */
    function elementInViewport(el) {
        el = el[0];
        var top = el.offsetTop;
        var left = el.offsetLeft;
        var width = el.offsetWidth;
        var height = el.offsetHeight;

        while (el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        return (
            top >= window.pageYOffset &&
            left >= window.pageXOffset &&
            (top + height) <= (window.pageYOffset + window.innerHeight) &&
            (left + width) <= (window.pageXOffset + window.innerWidth)
        );
    }

    function fixLeftSide() {
        var fixedSliderWrapper = $('.js-fixed-slider-wrapper'),
            fixedSlider = $('.js-fixed-slider');
            params = $('.params');

        if (fixedSlider.length == 0) {
            return false;
        }

        if ($(window).width() > 1099 && $(window).height() >= 650 && $(window).scrollTop() > fixedSliderWrapper.offset().top - 40 && !fixedSlider.hasClass('fixed') && (fixedSlider.height() < params.height())) {
            var sliderInitialWidth = fixedSlider.outerWidth();
            fixedSlider.addClass('fixed').css('width', sliderInitialWidth);
        } else if (($(window).width() < 1100 || $(window).height() < 650 || $(window).scrollTop() <= fixedSliderWrapper.offset().top - 40) && fixedSlider.hasClass('fixed')) {
            fixedSlider.removeClass('fixed');
        }

        // Если прижимаем к футеру
        if (fixedSlider.hasClass('fixed') && $(window).scrollTop() > $('.js-fixed-stopper').offset().top - (fixedSlider.outerHeight() + 40 + 80)) {
            fixedSlider.addClass('fixed-bottom');
            var top = $('.js-fixed-stopper').offset().top - fixedSliderWrapper.offset().top - fixedSlider.outerHeight();

                fixedSlider.css('top', top - 80);   // 80 - паддинг конфигуратора
        } else if (fixedSlider.hasClass('fixed-bottom')) {
            fixedSlider.removeClass('fixed-bottom');
            fixedSlider.css('top', '40px');
        }
    }

    function fixPriceBlock() {
        var fixedPriceBlock = $('.js-price-block'),
            fixedPriceBlockWrapper = $('.js-price-block-wrapper');

        if (fixedPriceBlock.length == 0) {
            return false;
        }

        if ($(window).width() > 1099 && $(window).height() >= 650 && $(window).scrollTop() > fixedPriceBlockWrapper.offset().top - 40 && !fixedPriceBlock.hasClass('fixed')) {
            fixedPriceBlock.addClass('fixed');
        } else if (($(window).width() < 1100 || $(window).height() < 650 || $(window).scrollTop() <= fixedPriceBlockWrapper.offset().top - 40) && fixedPriceBlock.hasClass('fixed')) {
            fixedPriceBlock.removeClass('fixed');
        }

        // Если прижимаем к футеру
        // 80 - паддинг конфигуратора
        if (fixedPriceBlock.hasClass('fixed') && $(window).scrollTop() > $('.js-fixed-stopper').offset().top - (fixedPriceBlock.outerHeight() + 40 + 80)) {
            fixedPriceBlock.addClass('fixed-bottom');
        } else if (fixedPriceBlock.hasClass('fixed-bottom')) {
            fixedPriceBlock.removeClass('fixed-bottom');
            fixedPriceBlock.css('top', '40px');
        }
    }

    $(document).scroll(function () {
        if (elementInViewport($('.steps'))) {
            $('.comet-1').addClass('animating-1');
            $('.comet-2').addClass('animating-2');
            $('.comet-3').addClass('animating-3');
        } else {
            $('.comet-1').removeClass('animating-1');
            $('.comet-2').removeClass('animating-2');
            $('.comet-3').removeClass('animating-3');
        }

        fixLeftSide();
        fixPriceBlock();
    });

    if (window.location.hash == "#configurator") {
        var destination = $('.configurator .block-title').offset().top - $('header').outerHeight();
        $("html").animate({ scrollTop: destination}, 1000 );
    }

    $('i.preview').mouseover(function(event){
        var preview = $(event.target);
        var previewHover = preview.find('.preview-hover');
        var top = preview.offset().top - previewHover.outerHeight() - $(window).scrollTop() - $('header').outerHeight();
        if(top < 0) {
            previewHover.css('top', -top - previewHover.outerHeight() + 5);
        } else {
            previewHover.css('top', -previewHover.outerHeight());
        }

    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/plugin-init.js